import type { SetupContext } from "vue";
import { defineComponent } from "vue";

/**
 * Mixin for propagating focus events out of a control"
 */
export default defineComponent({
  methods: {
    /**
     * Bubble (re-emit) a system event (e.g. click, focus, blur).
     */
    bubbleEvent(event: FocusEvent) {
      this.bubbleCustomEvent(event.type, event);
    },

    /**
     * Bubble (re-emit) a custom component event.
     */
    bubbleCustomEvent(eventName: string, event: FocusEvent) {
      if (!event) {
        // not certain why this happens
        return;
      }
      this.$emit(eventName, event);
    },

    /**
     * Needed for controls which cannot actually be focused (e.g. switches)
     */
    setFocused(isFocused: boolean) {
      if (isFocused) {
        this.$emit("focus", new FocusEvent("focus"));
      } else {
        this.$emit("blur", new FocusEvent("blur"));
      }
    },
  },
});

/**
 * Vue does not automatically bubble events of wrapped components.
 */
export function useEventBubbling(context: SetupContext) {
  return {
    bubbleEvent(event: Event) {
      if (!event) {
        // not certain why this happens
        return;
      }
      context.emit(event.type, event);
    },
    bubbleCustomEvent(eventName: string, event: Event) {
      if (!event) {
        // not certain why this happens
        return;
      }
      context.emit(eventName, event);
    },
  };
}
